<app-exam-header [pageTitle]="'About Us'"></app-exam-header>
<div class="page-content">

    <!-- Team Member Details-->
    <section class="pbmit-team-single">
        <div class="container">
            <div class="pbmit-team-details">
                <div class="pbmit-team-single-info">
                    <div class="row align-items-center">
                        <div class="col-md-12 col-lg-6">
                            <div class="pbmit-team-left-inner">
                                <div class="pbmit-featured-wrapper">
                                    <img src="../../../../assets/images/blog-02.jpg" class="img-fluid" alt="">
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12 col-lg-6">
                            <div class="pbmit-team-des">
                                <div class="pbmit-team-summary">
                                    <h4 class="pbmit-team-designation">CEO/Founder</h4>
                                    <h2 class="pbmit-team-title">{{founderObj.title}}</h2>
                                </div>
                                <div class="pbmit-short-description" [innerHTML]="founderObj.description"></div>
                                <ul class="pbmit-single-team-info">
                                    <li>
                                        <label>Phone</label> 123456789
                                    </li>
                                    <li>
                                        <label>Email</label>
                                        <a href="mailto:info@sharaniponguru.me">info@sharaniponguru.me</a>
                                    </li>
                                    <li>
                                        <label>Website</label> 
                                        <a href="https://www.sharaniponguru.me">www.sharaniponguru.me</a> 
                                    </li>
                                    <li>
                                        <label>Fax</label> 123456789
                                    </li>
                                </ul>
                                <ul class="pbmit-social-links pbmit-team-social-links">
                                    <li class="pbmit-social-li pbmit-social-facebook">
                                        <a href="#" title="Facebook" target="_blank">
                                            <span><i class="pbmit-base-icon-facebook-squared"></i></span>
                                        </a>
                                    </li>
                                    <li class="pbmit-social-li pbmit-social-twitter">
                                        <a href="#" title="Twitter" target="_blank">
                                            <span><i class="pbmit-base-icon-twitter"></i></span>
                                        </a>
                                    </li>
                                    <li class="pbmit-social-li pbmit-social-linkedin">
                                        <a href="#" title="LinkedIn" target="_blank">
                                            <span><i class="pbmit-base-icon-linkedin-squared"></i></span>
                                        </a>
                                    </li>
                                    <li class="pbmit-social-li pbmit-social-youtube">
                                        <a href="#" title="Youtube" target="_blank">
                                            <span><i class="pbmit-base-icon-youtube-play"></i></span>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="team-details-wrap">
                    <h3 class="pbmit-title">{{aboutObj.title}}</h3>
                    <p [innerHTML]="aboutObj.description"></p>
                    <div class="row">
                        <div class="col-xl-6 col-md-12">
                            <div>
                                <h3 class="pbmit-title">{{skillsObj.title}}</h3>
                                <p [innerHTML]="skillsObj.description"></p>
                                <div class="progressbar">
                                    <span class="progress-label">Career coaching</span>
                                    <div class="progress progress-lg progress-percent-bg">
                                        <div class="progress-bar aos aos-init aos-animate" data-aos="slide-right" data-aos-delay="200" data-aos-duration="1000" data-aos-easing="ease-in-out" role="progressbar" aria-valuenow="90" aria-valuemin="0" aria-valuemax="100" style="width:90%"></div>
                                        <span class="progress-percent">90%</span>
                                    </div>
                                </div>
                                <div class="progressbar">
                                    <span class="progress-label">Increase power</span>
                                    <div class="progress progress-lg progress-percent-bg">
                                        <div class="progress-bar aos aos-init aos-animate" data-aos="slide-right" data-aos-delay="200" data-aos-duration="1000" data-aos-easing="ease-in-out" role="progressbar" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100" style="width:80%"></div>
                                        <span class="progress-percent">80%</span>
                                    </div>
                                </div>
                                <div class="progressbar">
                                    <span class="progress-label">Business Course</span>
                                    <div class="progress progress-lg progress-percent-bg">
                                        <div class="progress-bar aos aos-init aos-animate" data-aos="slide-right" data-aos-delay="200" data-aos-duration="1000" data-aos-easing="ease-in-out" role="progressbar" aria-valuenow="70" aria-valuemin="0" aria-valuemax="100" style="width:70%"></div>
                                        <span class="progress-percent">70%</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-6 col-md-12">
                            <div class="team-list-group">
                                <h3 class="pbmit-title">{{benefitsObj.title}}</h3>
                                <p [innerHTML]="benefitsObj.description"></p>
                                <div class="row">
                                    <div class="col-md-6">
                                        <ul class="list-group list-group-borderless">
                                            <li class="list-group-item">
                                                <i aria-hidden="true" class="fa fa-check"></i> Experience of Coaching
                                            </li>
                                            <li class="list-group-item">
                                                <i aria-hidden="true" class="fa fa-check"></i> Committed to our client Life
                                            </li>
                                            <li class="list-group-item">
                                                <i aria-hidden="true" class="fa fa-check"></i> Peoples Increase Life Success
                                            </li>
                                            <li class="list-group-item">
                                                <i aria-hidden="true" class="fa fa-check"></i> People who made inspiring
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="col-md-6">
                                        <ul class="list-group list-group-borderless">
                                            <li class="list-group-item">
                                                <i aria-hidden="true" class="fa fa-check"></i> Experience of Coaching
                                            </li>
                                            <li class="list-group-item">
                                                <i aria-hidden="true" class="fa fa-check"></i> Committed to our client Life
                                            </li>
                                            <li class="list-group-item">
                                                <i aria-hidden="true" class="fa fa-check"></i> Peoples Increase Life Success
                                            </li>
                                            <li class="list-group-item">
                                                <i aria-hidden="true" class="fa fa-check"></i> People who made inspiring
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="team-details-list-group">
                        <h3 class="pbmit-title">{{experienceObj.title}}</h3>
                        <p [innerHTML]="experienceObj.description"></p>
                    </div>
                    <div class="team-contact">
                        <h2 class="pbmit-title">{{contactObj.title}}</h2>
                        <p [innerHTML]="contactObj.description"></p>
                        <form class="pbmit-team-form">
                            <div class="row g-4">
                                <div class="col-md-12 col-lg-6">
                                    <input type="text" class="form-control mb-0" placeholder="Your Name *" name="Your Name *">
                                </div>
                                <div class="col-md-12 col-lg-6">
                                    <input type="email" class="form-control" placeholder="Your Email *" name="Your Email *">
                                </div>
                                <div class="col-sm-12 mt-0">
                                    <textarea class="form-control" placeholder="Message" name="message"></textarea>
                                </div>
                                <div>
                                    <a class="pbmit-btn pbmit-btn-blackish">Send Massage</a>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- Team Member Details end -->

</div>
<app-exam-footer></app-exam-footer>